
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/brands/[slug]",
      function () {
        return require("private-next-pages/shop/brands/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/brands/[slug]"])
      });
    }
  